import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import Button from 'components/Button';
import AddressCard from 'apps/addresses/blocks/AddressCard';
import {
  AddressWrapper,
  SingleCardWrapper,
  ActionsRowWrapper,
} from 'apps/addresses/blocks/Address.styles';

const Address = props => {
  const { t, manager } = props;
  const { value } = manager?.fieldStore;

  const doNotRenderAddressValue =
    manager?.fieldStore.conf.doNotRenderAddressValue;

  const inEditMode = !!value;

  return (
    <AddressWrapper>
      {value && !doNotRenderAddressValue && (
        <SingleCardWrapper>
          <AddressCard singleCard address={value} />
        </SingleCardWrapper>
      )}
      <ActionsRowWrapper>
        <Button
          outline
          size='small'
          variant='tertiary'
          icon={inEditMode ? 'edit' : 'add'}
          data-testid={
            inEditMode ? 'change-delivery-address' : 'add-delivery-address'
          }
          text={
            inEditMode
              ? t('Change Delivery Address')
              : t('Add Delivery Address')
          }
          onClick={() => {
            manager?.BeginChangeAddress();
          }}
        />
      </ActionsRowWrapper>
    </AddressWrapper>
  );
};

Address.propTypes = {
  t: PropTypes.func,
  manager: PropTypes.object,
};

export default withNamespaces()(observer(Address));
